var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForsightLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 280,
    viewBox: "0 0 284 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.83 28.6795H0.27002V0.80954H41.83V28.6795ZM28.13 77.5395H0.27002V119.34H28.13V77.5395ZM28.13 161.24H0.27002V203.04H28.13V161.24ZM41.83 251.91H0.27002V279.77H41.83V251.91ZM120.89 251.91H79.32V279.77H120.89V251.91ZM120.89 0.909515H79.32V28.7695H120.89V0.909515ZM283.39 0.78952H158.14V28.6595H255.69V251.91H158.14V279.77H283.55V0.769531L283.39 0.78952ZM200.08 82.0395H83.63V198.52H200.08V82.0395Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForsightLogoIcon);
export default __webpack_public_path__ + "static/media/forsight_logo_icon.eea59b9defad11d6eb0e8f57bec224b7.svg";
export { ForwardRef as ReactComponent };